<template>
    <div id="referalLandingDiv">
        <HeaderVue />
        <div class="loading">
            <div class="loading-img">
                <img src="static/images/walk.gif" alt="">
            </div>
        </div>
        <div class="credit-section">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-4  cr-left">
                        <h3>Your Credit</h3>
                        <h2>Rs.{{creditPoint}}</h2>
                        <router-link to="/lab"><button type="button" class="btn btn-primary">USE NOW</button></router-link>
                    </div>
                    <div class="col-sm-8">
                        <div class="cr-content">
                            <h2>Refer Now </h2>
                            <div class="cr-code"><h5>{{referralCode}}</h5></div>
                            <div class="cr-cod-con">
                                    <p>{{description}}</p>
                            </div>
                           
                            <social-sharing 
                                            v-bind:title="description"
                                            v-bind:description="description"    
                                            v-bind:quote="description"
                                            v-bind:hashtags="hashtags"
                                            v-bind:twitter-user="twitterUser"
                                            v-bind:url="referralUrl"
                                            inline-template>
                                <div class="share-btn mt-3 mt-b ">
                                    Share Via :
                                    <network network="facebook">
                                        <i class="fa fa-facebook-square"></i>
                                    </network>
                                    <network network="twitter">
                                        <i class="fa fa-twitter"></i>
                                    </network>
                                </div>
                            </social-sharing>
                           
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="inline-img">
            <div>
                <a href="/redirect/labs/Dengue_Profile"><img src="static/images/book1.png" alt=""></a>            
            </div>
            <div>
                 <a href="/redirect/labs/Mega_Health_Checkup"><img src="static/images/book3.png" alt=""></a>                
            </div>
        </div>
        <!-- <div class="wraper-mob">
            <h2>Refer Now</h2>
            <div class="container">
                <div class="row">
                    <div class="cr-mob">
                        <div class="col-sm-12 ">
                            <img src="static/images/book-mob3.png" alt="">
                        </div>
                        <div class="col-sm-12 ">
                            <img src="static/images/book-mob4.png" alt="">
                        </div>
                    </div>
                   <div class="cr-mob">
                        <div class="col-sm-12 ">
                            <img src="static/images/book-mob1.png" alt="">
                        </div>
                        <div class="col-sm-12 ">
                            <img src="static/images/book-mob2.png" alt="">
                        </div>
                   </div>
                </div>
            </div>
        </div> -->
        <!-- credit-section_end -->
        <div class="fixed-footer">
            <div class="container">
                <div class="row">
                    <div class="col-sm-1">
                        <h5 class="text-sm-left foot-title text-nowrap">
                            <b>
                                <span class="blue-color">Our Lab</span>
                                <br class="sm-hidden">
                                <span class="green-color">Partners</span>
                            </b>
                        </h5>
                        <div class="left-line"></div>
                    </div>
                    <div class="col-sm-11">
                        <div class="slider">
                            <div class="slide">
                                <div class="card">
                                    <img class="card-img-top" src="static/images/client/medall.jpg" alt="Medall Health Care Pvt Ltd">
                                </div>
                            </div>
                            <div class="slide">
                                <div class="card">
                                    <img class="card-img-top" src="static/images/client/metroplis.png" alt="Lister Metropolis Healthcare Limited">
                                </div>
                            </div>
                            <div class="slide">
                                <div class="card">
                                    <img class="card-img-top" src="static/images/client/bioline.jpg" alt="Bio Line Laboratory">
                                </div>
                            </div>
                            <div class="slide">
                                <div class="card">
                                    <img class="card-img-top" src="static/images/client/techmed.jpg" alt="Techmed Health Centre & Diagnostic">
                                </div>
                            </div>
                            <div class="slide">
                                <div class="card">
                                    <img class="card-img-top" src="static/images/client/srl.png" alt="Specialtys Medical Diagnostic(SRL Diagnostics)">
                                </div>
                            </div>
                            <div class="slide">
                                <div class="card">
                                    <img class="card-img-top" src="static/images/client/vrr.jpg" alt="VRR Diagnostics">
                                </div>
                            </div>
                            <div class="slide">
                                <div class="card">
                                    <img class="card-img-top" src="static/images/client/medcis.png" alt="Medcis Pathlabs India Pvt. Ltd">
                                </div>
                            </div>
                            <div class="slide">
                                <div class="card">
                                    <img class="card-img-top" src="static/images/client/pathcare.jpg" alt="Path Care Labs Pvt. Ltd">
                                </div>
                            </div>
                            <div class="slide">
                                <div class="card">
                                    <img class="card-img-top" src="static/images/client/aarthi.jpg" alt="Aarthi Scans And Labs">
                                </div>
                            </div>
                            <div class="slide">
                                <div class="card">
                                    <img class="card-img-top" src="static/images/client/primex.png" alt="Primex Scans and Labs">
                                </div>
                            </div>
                            <!--<div class="slide">
                                <div class="card">
                                    <img class="card-img-top" src="static/images/client/american.jpg" alt="The American Clinical laboratories">
                                </div>
                            </div>-->
                            <!--<div class="slide">
                                <div class="card">
                                    <img class="card-img-top" src="static/images/client/best.png" alt="Best Diagno labs">
                                </div>
                            </div>-->
                            <div class="slide">
                                <div class="card">
                                    <img class="card-img-top" src="static/images/client/microbiological.jpg" alt="Microbiological Laboratory">
                                </div>
                            </div>
                            <div class="slide">
                                <div class="card">
                                    <img class="card-img-top" src="static/images/client/hitech.jpg" alt="Hitech Diagnostic Centre">
                                </div>
                            </div>
                            <div class="slide">
                                <div class="card">
                                    <img class="card-img-top" src="static/images/client/asian.jpg" alt="Asian Diagnostics">
                                </div>
                            </div>
                            <div class="slide">
                                <div class="card">
                                    <img class="card-img-top" src="static/images/client/diagnolabs.jpg" alt="Diagno labs Pvt Ltd">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <FooterVue /> -->
    </div>
</template>
<script>
import Vue from "vue";
import HeaderVue from "@/components/web/Header";
// import FooterVue from "@/components/web/Footer";
import _ from 'underscore'
export default {
  name: "ReferralLanding",
  components: {
    HeaderVue,
    // FooterVue
  },
  mounted () {
      this.getProfile()
  },
  beforeCreate() {},
  created() {
    this.getProfile()
    setTimeout(function () {
        $('.slider').bxSlider({
            slideWidth: 'auto',
            minSlides: 1,
            maxSlides: 6,
            moveSlides: 6,
            slideMargin: 10,
            auto: true,
            autoControls: true
        })
        $("#carouselExampleControls").carousel()
        var footHeight = $('.fixed-footer').outerHeight()
        $('body').css('margin-bottom', footHeight)
    }, 100)
  },
  data() {
    return {
      referralCode : '',
      referralUrl : 'https://labotist.com/',
      title : 'Labotist - Referral Program',
      quote : 'Hi, \r\n Here is the referral link to register with Labotist.com. They provide home blood test service and on registering you will get a credit of Rs 150 which you can use against your bookings with them, for blood test at home. \r\n   Labotists offers over 1000+ tests in partnership with 50 labs in Bengaluru and Chennai.',
      description : 'Hi,  \r\n  Here is the referral link to register with Labotist.com. They provide home blood test service and on registering you will get a credit of Rs 150 which you can use against your bookings with them, for blood test at home. \r\n   Labotists offers over 1000+ tests in partnership with 50 labs in Bengaluru and Chennai.',
      hashtags : 'Labotist,free blood sample collection,',
      twitterUser : 'Labotist.com'
    }
  },
  methods: {
    getProfile: function () {
        try {
            if (this.$localStorage.get('loggedIn') && this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
                var data = {}
                Promise.resolve(this.$GET('patient/getProfile', data)).then(function (res) {
                    if (res.response_code === 0) {
                    if (res.response) {
                        _.each(res.response.Addresses, function (item) {
                        if (item.isDefault === 1) {
                            this.address = item.address
                        }
                        })
                    }
                    console.log("inside the process")
                    console.log(res.response)
                    this.firstName = res.response.Patient.firstName
                    this.lastName = res.response.Patient.lastName
                    this.email = res.response.email
                    this.phone1 = res.response.Patient.phone1
                    this.phone2 = res.response.Patient.phone2
                    this.dob = res.response.Patient.dob ? res.response.Patient.dob : ''
                    this.sex = res.response.Patient.sex
                    this.creditPoint = res.response.Patient.creditPoint
                    this.referralCode = res.response.Patient.referralCode
                    this.referralUrl = this.$signupUrl + this.$encryptString(this.referralCode)
                    this.credits = res.response.credits
                    }
                    this.$hidePageLoading()
                }.bind(this)).catch(function (err) {
                    console.error(err)
                })
            }
        } catch (e) {
            console.error('method:getProfile', e)
        }
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/web/Public/ReferralLanding.vue